import React, { Component } from "react";
import PropTypes from "prop-types";

class Button extends Component {
  static propTypes = {
    onPress: PropTypes.func,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    label: PropTypes.string.isRequired,
    loadingText: PropTypes.string,
    style: PropTypes.object,
    type: PropTypes.oneOf(["button", "submit", "reset", "anchor"]),
  };

  render() {
    const {
      onPress,
      label,
      loading = false,
      loadingText = "Loading...",
      type = "button",
      disabled = false,
      style: customStyle,
      ...rest
    } = this.props;
    const style = disabled
      ? { ...styles.button, ...styles.disabled }
      : styles.button;

    const Comp = type === "anchor" ? "a" : "button";
    const buttonText = loading ? loadingText : label;
    return (
      <Comp
        disabled={disabled}
        style={{ ...style, ...customStyle }}
        onClick={onPress}
        type={type}
        rel="nofollow"
        {...rest}
      >
        {buttonText}
      </Comp>
    );
  }
}

const styles = {
  button: {
    background: "#026fb8",
    border: "none",
    borderRadius: 4,
    color: "#ffffff",
    cursor: "pointer",
    float: "unset",
    fontSize: 13,
    fontWeight: "bold",
    padding: "7px 20px 7px 20px",
    textDecoration: "none",
  },
  disabled: {
    background: "#9d9d9d",
    cursor: "default",
  },
};

export default Button;
